import { DataListView, PhoneDisplay } from '@farmshare/ui-components';
import { Box } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { vendorState } from 'state';

import { type User } from '../../../lib/graphql';
import { formatUserRelationshipType } from 'features/customers/helpers/formatting';

interface CustomerPreviewProps {
  customer: User;
}

export function CustomerPreview({ customer }: CustomerPreviewProps) {
  const vendor = useRecoilValue(vendorState);

  const relationshipType = formatUserRelationshipType(customer, vendor?._id);

  const address = customer.address
    ? [
        customer.address.address_1,
        customer.address.address_2,
        `${customer.address.city}, ${customer.address.state} ${customer.address.postcode}`,
      ]
        .filter(Boolean)
        .join(', ')
    : null;

  return (
    <Box>
      <DataListView
        data={[
          {
            title: 'First Name',
            value: customer.first_name || '-',
          },
          {
            title: 'Last Name',
            value: customer.last_name || '-',
          },
          {
            title: 'Email',
            value: customer.email || '-',
          },
          {
            title: 'Phone',
            value: customer.phone ? (
              <PhoneDisplay phone={customer.phone} />
            ) : (
              '-'
            ),
          },
          {
            title: 'Farm/Company',
            value: customer.company || '-',
          },
          {
            title: 'Type',
            value: relationshipType || '-',
          },
          {
            title: 'Address',
            value: address || '-',
          },
        ]}
      />
    </Box>
  );
}
